// @ts-nocheck
import * as React from 'react';
import type { SVGProps } from 'react';

const rows = [
  {
    icon: 'book',
    title: 'Inspire 365',
    desc: 'Students arrive mentally stronger every morning.',
    tag: 'DAILY',
    tagColor: '#16a34a',
    tagBg: '#eaf7ee',
    tagDot: true,
  },
  {
    icon: 'users',
    title: 'Ai childcare counselling',
    desc: 'AI guidance covering 44 key parenting challenges',
    tag: 'Automated',
    tagColor: '#7c3aed',
    tagBg: '#f7f2ff',
    tagDot: true,
  },
  {
    icon: 'chart',
    title: 'Ai powered student information',
    desc: '360 student intelligence with daily & weekly risk insights',
    tag: 'Automated',
    tagColor: '#7c3aed',
    tagBg: '#f7f2ff',
    tagDot: true,
  },
  {
    icon: 'globe',
    title: 'Multilingual Comms',
    desc: 'Parent communication across 10+ Indian languages',
    tag: '24/7 365 days',
    tagColor: '#16a34a',
    tagBg: '#eaf7ee',
    tagDot: true,
  },
  {
    icon: 'chat',
    title: 'Ai Parental Helpdesk',
    desc: '24/7 AI-assisted parenting & emotional support',
    tag: 'On demand',
    tagColor: '#f97316',
    tagBg: '#fff7ed',
    tagDot: true,
  },
  {
    icon: 'grid',
    title: 'Ai feedback and survey',
    desc: 'Smart feedback loops that increase parent trust',
    tag: 'Automated',
    tagColor: '#7c3aed',
    tagBg: '#f7f2ff',
    tagDot: true,
  },
];

function Icon({ name, color = 'currentColor', className = '' }) {
  const common: SVGProps<SVGSVGElement> = {
    width: 20,
    height: 20,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: color,
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
    className,
    'aria-hidden': 'true',
  };

  const paths = {
    home: (
      <>
        <path d="M3 10.5 12 3l9 7.5" />
        <path d="M5 9.5V21h14V9.5" />
      </>
    ),
    book: (
      <>
        <path d="M4 5.5A2.5 2.5 0 0 1 6.5 3H20v15H6.5A2.5 2.5 0 0 0 4 20.5z" />
        <path d="M4 20.5V5.5" />
      </>
    ),
    users: (
      <>
        <circle cx="9" cy="8" r="3" />
        <path d="M3.5 19a5.5 5.5 0 0 1 11 0" />
        <path d="M16 6a3 3 0 0 1 0 6" />
        <path d="M18 19a5 5 0 0 0-3-4.6" />
      </>
    ),
    chart: (
      <>
        <path d="M5 21V11" />
        <path d="M12 21V4" />
        <path d="M19 21v-7" />
      </>
    ),
    globe: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M3 12h18" />
        <path d="M12 3c2.6 2.5 4 5.7 4 9s-1.4 6.5-4 9c-2.6-2.5-4-5.7-4-9s1.4-6.5 4-9z" />
      </>
    ),
    chat: <path d="M4 5h16v11H8l-4 4z" />,
    grid: (
      <>
        <rect x="4" y="4" width="16" height="16" rx="2" />
        <path d="M4 10h16" />
        <path d="M10 10v10" />
      </>
    ),
    arrow: (
      <>
        <path d="M5 12h14" />
        <path d="M13 6l6 6-6 6" />
      </>
    ),
    shield: (
      <>
        <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
        <path d="m9 12 2 2 4-4" />
      </>
    ),
    preview: (
      <>
        <path d="M15 3h6v6" />
        <path d="M10 14 21 3" />
        <path d="M20 13a8 8 0 1 1-9-9" />
      </>
    ),
    settings: (
      <>
        <circle cx="12" cy="12" r="3" />
        <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06A1.65 1.65 0 0 0 15 19.4a1.65 1.65 0 0 0-1 .6 1.65 1.65 0 0 0-.38 1.05V21a2 2 0 1 1-4 0v-.09A1.65 1.65 0 0 0 8.6 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-.6-1 1.65 1.65 0 0 0-1.05-.38H3a2 2 0 1 1 0-4h.09A1.65 1.65 0 0 0 4.6 8.6a1.65 1.65 0 0 0-.33-1.82l-.06-.06A2 2 0 1 1 7.04 3.9l.06.06A1.65 1.65 0 0 0 9 4.6a1.65 1.65 0 0 0 1-.6 1.65 1.65 0 0 0 .38-1.05V3a2 2 0 1 1 4 0v.09A1.65 1.65 0 0 0 15.4 4.6a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9c.18.38.39.7.72.94.3.21.66.33 1.04.33H21a2 2 0 1 1 0 4h-.09A1.65 1.65 0 0 0 19.4 15z" />
      </>
    ),
  };

  return <svg {...common}>{paths[name]}</svg>;
}

function MicrosoftMark() {
  return (
    <span className="logo-word logo-word--microsoft">
      <span className="ms-grid" aria-hidden="true">
        <i />
        <i />
        <i />
        <i />
      </span>
      Microsoft
    </span>
  );
}

function MetaMark() {
  return (
    <span className="logo-word logo-word--meta">
      <img src="/admissions-assured/meta-icon.svg" alt="" aria-hidden="true" />
      Meta
    </span>
  );
}

function GoogleMark() {
  return (
    <span className="logo-word logo-word--google">
      <img src="/admissions-assured/google-icon.svg" alt="" aria-hidden="true" />
      Google
    </span>
  );
}

export default function HomeApp({ onOpenConsole, onOpenDemo }) {
  return (
    <main className="aa-home">
      <div className="aa-home__glow" />
      <svg className="aa-home__rings" viewBox="0 0 700 800" preserveAspectRatio="xMidYMin slice" aria-hidden="true">
        <g fill="none" stroke="#e3e6ee" strokeWidth="1">
          <circle cx="350" cy="250" r="180" />
          <circle cx="350" cy="250" r="320" />
          <circle cx="350" cy="250" r="470" />
          <circle cx="350" cy="250" r="620" />
        </g>
      </svg>

      <section className="aa-home__main">
        <div className="hero-grid">
          <section className="hero-copy" aria-labelledby="home-title">
            <div className="live-pill">
              <span />
              20 AI employees working right now
            </div>
            <h1 id="home-title">
              Admissions,
              <br />
              <span>assured.</span>
              <svg className="hero-underline" viewBox="0 0 190 24" aria-hidden="true">
                <path d="M3 18c48-10 100-17 184-2" />
              </svg>
            </h1>
            <p>
              The AI command centre that turns every enquiry into an admission and every parent into an
              advocate. Before they ever walk in.
            </p>
            <div className="hero-copy__actions">
              <button className="home-btn home-btn--primary home-btn--large" type="button" onClick={onOpenConsole}>
                Open your console <Icon name="arrow" color="#fff" />
              </button>
              <button className="home-btn home-btn--ghost home-btn--large" type="button" onClick={onOpenDemo}>
                See it live
              </button>
            </div>
            <p className="hero-copy__note">
              <Icon name="shield" color="#19b563" />
              No setup. Live in 2-3 hours. One school per region.
            </p>
            <div className="backed-row">
              <span>Backed by</span>
              <MicrosoftMark />
              <MetaMark />
              <GoogleMark />
            </div>
          </section>

          <section className="intelligence-card" aria-label="Intelligence layer">
            <header>
              <div>
                <span className="status-dot" />
                Intelligence layer live
              </div>
              <span>6 of 20 shown</span>
            </header>
            <div className="intelligence-card__list">
              {rows.map((row) => (
                <article className="intel-row" key={row.title}>
                  <div className="intel-row__icon">
                    <Icon name={row.icon} color="#2563eb" />
                  </div>
                  <div className="intel-row__copy">
                    <h2>{row.title}</h2>
                    <p>{row.desc}</p>
                  </div>
                  <span className="intel-row__tag" style={{ color: row.tagColor, background: row.tagBg }}>
                    {row.tagDot && <span style={{ background: row.tagColor }} />}
                    {row.tag}
                  </span>
                </article>
              ))}
            </div>
          </section>
        </div>
        <section className="stats-band" aria-label="Admissions Assured outcomes">
          <div>
            <strong>100<span>%</span></strong>
            <p>of enquiries captured - zero missed</p>
          </div>
          <div>
            <p>Up to</p>
            <strong><span>₹</span>2.5<span>Cr</span></strong>
            <p>new admissions potential, per year</p>
          </div>
          <div>
            <strong>60<span>%</span></strong>
            <p>more on-time fee collection</p>
          </div>
          <div>
            <strong>10<span>+</span></strong>
            <p>Indian languages, every channel</p>
          </div>
        </section>
      </section>
    </main>
  );
}
